import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from '@azure/msal-browser';
import { AuthRepository } from 'features/auth/repositories/AuthRepository';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID}`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
});

const tokenRequestScopes = [
  `api://${import.meta.env.VITE_AZURE_AD_CLIENT_ID}/access_as_user`,
];

let interactiveRenewalInProgress = false;

(async () => {
  await msalInstance.initialize();

  const result = await msalInstance.handleRedirectPromise();

  if (result?.account) {
    const repository = new AuthRepository();
    await repository.invalidateAuthenticatedUserCache();
  }
})();

export async function getAccessToken(): Promise<string> {
  await msalInstance.initialize();

  const activeAccount =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  if (!activeAccount) {
    return '';
  }

  try {
    const authResult = await msalInstance.acquireTokenSilent({
      scopes: tokenRequestScopes,
      account: activeAccount,
    });

    return authResult.accessToken;
  } catch (error) {
    console.error(error);

    // A renovação silenciosa falhou porque a sessão SSO com a Microsoft
    // expirou/precisa de reautenticação (ex.: inatividade prolongada).
    // Em vez de devolver token vazio e forçar logout manual, tentamos
    // renovar de forma interativa (redirect) antes de desistir.
    if (
      error instanceof InteractionRequiredAuthError &&
      !interactiveRenewalInProgress
    ) {
      interactiveRenewalInProgress = true;

      try {
        await msalInstance.acquireTokenRedirect({
          scopes: tokenRequestScopes,
          account: activeAccount,
        });
      } catch (redirectError) {
        interactiveRenewalInProgress = false;
        console.error(redirectError);
      }
    }

    return '';
  }
}

export async function isUserAuthenticated() {
  await msalInstance.initialize();

  const activeAccount =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];

  return !!activeAccount;
}
